import { ArticleFooterTheme } from '@/components/ArticleFooter/theme';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';
import { StandaloneTag } from '../Tag';
import { Link as StandaloneLink } from '@/components/Link';
import { ArticleHeaderTheme } from '@/components/ArticleHeader/theme';

const $ = GenericSlotFactory({ theme: ArticleFooterTheme });

const Base = $({ as: 'div', slot: 'base' });
const Tags = $({ as: 'ul', slot: 'tags' });
const Tag = GenericSlot({ as: StandaloneTag, theme: ArticleFooterTheme.Tag });
const Disclaimer = $({ as: 'div', slot: 'disclaimer' });
const DisclaimerText = $({ as: 'p', slot: 'disclaimerText' });
const DisclaimerLink = GenericSlot({ as: StandaloneLink, theme: ArticleFooterTheme.DisclaimerLink });

export const ArticleFooter = Object.assign(Base, {
  Disclaimer,
  DisclaimerText,
  DisclaimerLink,
  Tags,
  Tag,
});
